export const APP_WIDTH = 1200;
export const DESIGN_WIDTH = 1920;
export const MIN_DESIGN_WIDTH = 414;

export default function adaptSize(size) {
	return size /** (APP_WIDTH / DESIGN_WIDTH)*/;
}

